import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const NotFoundError = ({ titleTextId }) => <ErrorPage title="Not Found" titleTextId={ titleTextId } type="notfound" showButton onButtonClick={ () => history.go(-1) }>
  <LocalisedMessage
    id="notFound.content"
    values={ {
      // eslint-disable-next-line react/no-unstable-nested-components
      error404: chunks => <p className="cp-primary"><b>{ chunks }</b></p>
    } }
  />
</ErrorPage>;

NotFoundError.propTypes = {
  titleTextId: PropTypes.string
};

NotFoundError.defaultProps = {
  titleTextId: 'notFound.title'
};

export default injectIntl(NotFoundError);
